import React, { useState } from 'react'
import { reIndexTrees } from '../../../api/reIndexTrees'
import {
  Box,
  Button,
  Dialog,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

enum ReIndexStatus {
  notHappened,
  happening,
  withError,
  complete,
  acknowledged,
}

export function ReIndexButton({
  treeIds,
}: {
  treeIds: { treeId: string; versionId: string }
}) {
  const [reIndexStatus, setReIndexStatus] = useState(ReIndexStatus.notHappened)
  const [errors, setErrors] = useState('')

  const doReIndex = async () => {
    setReIndexStatus(ReIndexStatus.happening)
    setErrors('')
    const { result, errors } = await reIndexTrees(treeIds)
    if (result) {
      setReIndexStatus(ReIndexStatus.complete)
    } else {
      setErrors(errors?.map(({ message }) => message).join('\n') ?? '')
      setReIndexStatus(ReIndexStatus.withError)
    }
  }

  const ReIndexDialog = () => {
    const acknowledged = () => {
      if (reIndexStatus === ReIndexStatus.happening) return
      setReIndexStatus(ReIndexStatus.acknowledged)
      setErrors('')
    }
    if (reIndexStatus === ReIndexStatus.happening) {
      return (
        <Dialog open={true} onClose={acknowledged} fullWidth={true}>
          <DialogTitle>
            <Box textAlign="center">{'ReIndex Request...'}</Box>
          </DialogTitle>
        </Dialog>
      )
    }
    if (reIndexStatus === ReIndexStatus.complete) {
      return (
        <Dialog open={true} onClose={acknowledged} fullWidth={true}>
          <DialogTitle>
            <Box textAlign="center">{'ReIndex Successfully Initiated'}</Box>
          </DialogTitle>
        </Dialog>
      )
    }
    if (reIndexStatus === ReIndexStatus.withError) {
      return (
        <Dialog open={true} onClose={acknowledged} fullWidth={true}>
          <DialogTitle>{'ReIndex Failed To Initiate'}</DialogTitle>
          <DialogContentText padding="25px">{errors}</DialogContentText>
        </Dialog>
      )
    }
    return null
  }
  return (
    <>
      <ReIndexDialog />
      <Button
        disabled={reIndexStatus !== ReIndexStatus.notHappened}
        onClick={doReIndex}
      >
        ReIndex
      </Button>
    </>
  )
}
